var React = require('react');

function Three (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"#1DB4FF","d":"M30.23 16.19l14.9-9.86v19.31l-14.9-9.45zM1.38 3.72c-.13-1.98.97-3 2.34-3h38.66c1.37 0 2.47 1.02 3.07 3L23.41 17.63 1.37 3.72zM.95 25.64V6.34l14.9 9.85-14.9 9.45zm21.33-5.2c.23.16.5.23 1.13.23-.1 0 .16-.07.39-.22l3.9-2.59 17.68 11c-.55 1.32-1.64 2.35-3.01 2.35H3.72c-1.38 0-2.47-1.03-2.29-2.34l16.95-11.01 3.9 2.59z"}));
}

Three.defaultProps = {"viewBox":"0 0 46 32","height":"100%","width":"100%"};

module.exports = Three;

Three.default = Three;
